import type { TImageTransformations } from "@hsr/types";

// define image dimensions for different image transformations
export const imageWidths: TImageTransformations = {
  categoryimagetile: {
    width: 291,
    height: 194
  },
  categorynavigation: {
    width: 201,
    height: 134
  },
  imageteaserbig: {
    width: 1008,
    height: 504
  },
  imageteaserstandard: {
    width: 800,
    height: 400
  },
  productimage: {
    width: 528,
    height: 396
  },
  productimagecheckoutbig: {
    width: 114,
    height: 114
  },
  productimagecheckoutmedium: {
    width: 96,
    height: 96
  },
  productimagecheckoutmobile: {
    width: 90,
    height: 90
  },
  productimagelistitemdesktop: {
    width: 96,
    height: 48
  },
  productimagelistitemmobile: {
    width: 64,
    height: 64
  },
  productimagetile: {
    width: 276,
    height: 184
  },
  productimagezoom: {
    width: 800,
    height: 600
  },
  productthumbnail: {
    width: 80,
    height: 60
  },
  heroslide: {
    width: 1600,
    height: 500
  }
};
